// store/exercices/createExercicesSlice.ts

import { StateCreator } from 'zustand';
import { exercicesInitialState, ExercicesState } from './exercicesInitialState';
import { createFunctionalSetter } from '../storeCommons';
import { Exercice } from 'src/types';

/**
 * @french
 * Interface des actions liées aux exercices comptables.
 */
export interface ExercicesActions {
  setSecondaryActiveExercices: (exercices: Exercice[]) => void;
  setActiveExercices: (updater: Exercice[] | ((prev: Exercice[]) => Exercice[])) => void;
  setSelectedDateRangePeriod2: (range: [Date | null, Date | null] | null) => void;
  setSelectedDateRangePeriod1: (range: [Date | null, Date | null] | null) => void;
  setSelectedDateRange: (range: [Date | null, Date | null] | null) => void;
  reset: () => void;
}

/**
 * @french
 * Slice Zustand pour les actions liées aux exercices comptables.
 */
export const createExercicesSlice: StateCreator<
  ExercicesState & ExercicesActions,
  [],
  [],
  ExercicesActions
> = (set, get) => ({
  setSecondaryActiveExercices: (secondaryActiveExercices) => set({ secondaryActiveExercices }),

  setActiveExercices: createFunctionalSetter(get, set, 'activeExercices'),

  setSelectedDateRangePeriod2: (selectedDateRangePeriod2) => set({ selectedDateRangePeriod2 }),

  setSelectedDateRangePeriod1: (selectedDateRangePeriod1) => set({ selectedDateRangePeriod1 }),

  setSelectedDateRange: (selectedDateRange) => set({ selectedDateRange }),

  reset: () => set(exercicesInitialState),
});
